module.exports = __webpack_public_path__ + "img/onyinye.de8defbd.svg";